import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { pricingIncludes } from '../data/content';
export function Pricing() {
  return <section id="checkout" className="w-full scroll-mt-14 bg-white px-5 py-20 sm:px-8" data-id="element-130" data-mp="2oiz2i2v7eac5">
      <div className="mx-auto w-full max-w-2xl" data-id="element-131" data-mp="2jj4blzbfhkr3">
        <Reveal data-id="element-132" data-mp="2jke9anedcqx7">
          <h2 className="text-center font-display text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-133" data-mp="2jlyv9ommb1jg">
            Everything included,{' '}
            <span className="text-brand-strong" data-id="element-134" data-mp="1ru148ao8vua8">one single price.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-135" data-mp="25tspmwh3ccy9">
          <div className="relative mt-12 overflow-hidden rounded-card border border-navy/10 bg-white shadow-card" data-id="element-136" data-mp="25pv6wbyfdnew">
            <div className="flex justify-center" data-id="element-137" data-mp="3h74o0ru303d1">
              <p className="rounded-b-xl bg-gold px-6 py-2 text-2xs font-bold uppercase tracking-widest text-navy" data-id="element-138" data-mp="3h5tj2oowgpkc">
                Complete pack
              </p>
            </div>

            <div className="px-6 py-10 sm:px-12" data-id="element-139" data-mp="3vynief7a7xax">
              <h3 className="text-center font-display text-xl font-extrabold uppercase leading-snug tracking-tight text-navy sm:text-2xl" data-id="element-140" data-mp="4t5mxgphvg05">
                Flag Football Ready — Complete Pack
              </h3>

              <p className="mt-8 text-center font-display text-7xl font-black leading-none tracking-tight text-brand-strong sm:text-8xl" data-id="element-141" data-mp="er1trwbefosg">
                $27
              </p>
              <p className="mt-3 text-center text-sm font-semibold text-navy/70" data-id="element-142" data-mp="3d74g6al30n9y">
                One-time payment · digital download
              </p>

              <ul className="mx-auto mt-10 grid grid-cols-1 gap-3 rounded-card bg-tint p-6 sm:grid-cols-2" data-id="element-143" data-mp="3n63qrypeqszl">
                {pricingIncludes.map(item => <li key={item} className="flex items-center gap-2.5" data-id="element-144" data-mp="2uihc9ven63xy">
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-turf" data-id="element-145" data-mp="2ugdbhmc1hl1w">
                      <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-146" data-mp="2zf7r6fepmths" />
                    </span>
                    <span className="text-sm font-semibold text-navy" data-id="element-147" data-mp="2mhrsvo25dg34">{item}</span>
                  </li>)}
              </ul>

              <div className="mt-10" data-id="element-148" data-mp="315mobc7jhyjw">
                <CtaButton href="https://flag-football-ready.impultienda.ar/checkout" data-id="element-149" data-mp="318qx6mvy9igw" />
              </div>

              <p className="mt-5 text-center text-xs font-semibold text-navy/60" data-id="element-150" data-mp="2w9xn74fvg9lh">
                Secure payment · PDF format
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}